var map = {
	"./ActionsModal/Cambio.vue": 815,
	"./ActionsModal/SaveChanges.vue": 816,
	"./ActionsModal/index.vue": 277,
	"./agrocolor.vue": 2077,
	"./araporcei.vue": 2078,
	"./coplaca/ParcelasActionsMultiple.vue": 1173,
	"./coplaca/index.vue": 2079,
	"./default.vue": 2080,
	"./demo.vue": 2081,
	"./sites.vue": 326,
	"./widgets/auditorias.vue": 817,
	"./widgets/checklists.vue": 818,
	"./widgets/dictamenes.vue": 821,
	"./widgets/pacs.vue": 823,
	"./widgets/revisiones.vue": 820,
	"./widgets/solicitudes.vue": 819,
	"./widgets/toma_muestras.vue": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1784;